import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { OrderDataService } from '../data-service/order-data.service';
import { BaseComponent } from 'src/app/features/guided-order/base.component';
import { CurrentOrderService } from './current-order.service';

@Injectable({
  providedIn: 'root'
})
export class GuidedOrderResolver extends BaseComponent implements Resolve<Promise<void>> {
  constructor(private orderDataService: OrderDataService, public currentOrderService: CurrentOrderService) {
    super(currentOrderService);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const orderCode = route.params.param;
    return this.orderDataService.getOrder(orderCode).toPromise().then(x => {
      this.currentOrder.OrderCode = x.order.orderDetails.orderCode;
      this.currentOrder.AccountCode = x.order.account.accountCode;
      this.currentOrder.OrderingServiceCode = x.order.account.orderingServiceCode;
      this.currentOrder.QuotationCode = x.order.quotationContract.quotationCode;
      this.currentOrder.ContractCode = x.order.quotationContract.contractCode;
      this.currentOrder.ReceivingLabCode = x.order.quotationContract.receivingPartnerCode;
    });
  }
}
